import { z } from "zod";

export const SCHEMA_VERSION = "2" as const;

export const brandSchema = z.enum(["kinsa", "owlet"]);

export const surfaceSchema = z.enum([
  "home",
  "paywall",
  "checkout",
  "intake",
  "visit",
  "chat",
  "settings",
  "error",
  "widget",
  "other",
]);

/**
 * subscription_status mirrors Stripe's raw `Subscription.Status` (plus `none`
 * for no subscription on record). Source of truth is
 * `normalizeSubscriptionStatus()` in `@repo/stripe/lib/normalize-subscription-status`.
 * Used as the value field on `subscription_status_updated` and as
 * `user.custom.subscription_status` for current-state segments.
 *
 * Cancellation intent and payment are NOT folded in here — they're carried as
 * the separate orthogonal signals `cancels_at_period_end` and `has_paid`. So a
 * user can be `trialing` (or `active`) AND independently set to cancel / paid.
 */
export const subscriptionStatusSchema = z.enum([
  "trialing",
  "active",
  "past_due",
  "unpaid",
  "canceled",
  "paused",
  "incomplete",
  "incomplete_expired",
  "none",
]);

export const billingPeriodSchema = z.enum(["monthly", "annual", "unknown"]);

export const productNormalizedSchema = z.enum([
  "unlimited_rx",
  "pediatric_support",
  "pediatric_support_single",
  "pediatric_support_family",
  "other",
]);

export const baseEnvelopeSchema = z.object({
  schema_version: z.literal(SCHEMA_VERSION).optional(),
  event_id: z.string().optional(),
  brand: brandSchema.optional(),
});
